'use strict';
var quickView = require('core/product/quickView');
var modal = require('core/components/modal');
const { updateAddAllToCart } = require('core/product/detail');

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

function onModalShown() {
    var $modal = $('#quickViewModal');
    $modal.data('shown', true);
    if ($modal.data('loaded')) {
        $('body').trigger('quickview:ready', $modal); // sending custom event for slider init
    }
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    var $modal = $('#quickViewModal');
    $modal.data({
        loaded: false, // set to true when the ajax call finishes
        shown: false   // set to true when the modal finishes showing
    });
    $modal.off('shown.bs.modal', onModalShown).on('shown.bs.modal', onModalShown);
    $modal.find('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function(data) {
            var parsedHtml = modal.parseHtml(data.renderedTemplate);

            $modal.find('.modal-body').empty();
            $modal.find('.modal-body').html(parsedHtml.body);

            if (typeof yotpoWidgetsContainer !== 'undefined') {
                yotpoWidgetsContainer.initWidgets();
            }

            // Append assets from PDP Gallery Asset IDs attribute
            if ('pdpGalleryAssets' in data.product) {
                var pdpGalleryAssets = data.product.pdpGalleryAssets;
                var $assetSlides = $modal.find('.primary-images-main .pdp-gallery-asset');
                let hasVideo = false;

                $assetSlides.each((index, slide) => {
                    var $slideElement = $(slide);
                    var asset = pdpGalleryAssets[index];
                    if (asset.isVideo) {
                        hasVideo = true;
                    }

                    $.ajax({
                        url: asset.assetRenderUrl,
                        method: 'GET',
                        success: assetData => {
                            var $sliderContainer = $slideElement.closest('.slider-container');
                            $slideElement.html(assetData);

                            // after all assets are added, reinit any necessary javascript
                            if (index + 1 >= pdpGalleryAssets.length) {
                                $('body').trigger('quickview:ready', $('#quickViewModal')); // sending custom event for slider init
                                $slideElement.trigger('tooltip:init'); // reinit tooltips in case of hotspot asset

                                if (hasVideo) {
                                    $('body').trigger('ajax:load.ajaxEvents', [$sliderContainer]); // reinit videos in video/index.js
                                    $('body').trigger('slider:videosLoaded'); // trigger custom event set up in bindSliderUpdateEvent
                                }
                            }
                        },
                        error: err => {
                            console.error('There was an issue retrieving this asset: ', err);
                        }
                    });
                });
            }

            $modal.find('.modal-footer').html(parsedHtml.footer);
            $modal.find('.full-pdp-link').text(data.quickViewFullDetailMsg);
            $modal.find('.full-pdp-link').attr('href', data.productUrl);
            $modal.find('.modal-header .close .sr-only').text(data.closeButtonText);
            $modal.find('.enter-message').text(data.enterDialogMessage);
            $modal.find('#quickViewModal').modal('show');

            if (data.dialogTitle) {
                $modal.find('.modal-header').prepend('<div class="modal-title">' + data.dialogTitle + '</div>')
            }

            if (data.product.productType === 'set') {
                updateAddAllToCart();
            }

            $('body').trigger('modal:loaded', $modal); // sending custom event for scroll body sizing
            $('body').trigger('tooltip:init');
            $modal.data('loaded', true);
            if ($modal.data('shown')) {
                $('body').trigger('quickview:ready', $modal); // sending custom event for slider init
            }

            $.spinner().stop();
        },
        error: function() {
            $.spinner().stop();
        }
    });
}

quickView.showQuickview = function() {
  $('body').on('click', '.quickview', function (e) {
      e.preventDefault();
      var link = $(this).closest('a.quickview');
      var selectedValueUrl = link.data('href-quickview') || $(this).attr('href');
      $(e.target).trigger('quickview:show');
      modal.getModalHtmlElement('quickViewModal', 'quick-view-dialog');
      fillModalElement(selectedValueUrl);
  });
}

quickView.showQuickviewFromTile = function() {
    $('body').on('click', '.product-tile-quickview', function (e) {
        e.preventDefault();
        var selectedValueUrl = $(this).data('href-quickview') || $(this).attr('href');
        $(e.target).trigger('quickview:show');
        modal.getModalHtmlElement('quickViewModal', 'quick-view-dialog');
        fillModalElement(selectedValueUrl);
    });
}

quickView.updateAttribute = function() {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview>.bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container)
                .find('.product-id').text(response.data.product.id.split(" ")[0]);
        } else if ($('.set-items').length) {
            response.container.find('.product-id').text(response.data.product.id.split(" ")[0]);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
            $('.modal.show .full-pdp-link')
                .attr('href', response.data.product.selectedProductUrl);
        }
    });
}

/**
 * @description Check if minicart is open while quickview is open
 **/
quickView.handleMinicartEvent = function() {
    $('body').on("hidden.bs.modal", "#quickViewModal", function () {
        if ($('#minicartModal').hasClass('show') && !$('body').hasClass('modal-open')) {
            $('body').addClass('modal-open')
        }
    });
}

module.exports = quickView;